/* eslint-disable jsx-a11y/anchor-is-valid */
import {useFindRoleByName} from "hooks/query/role-query"
import {Outlet, useNavigate, useParams} from "react-router-dom"
import {UpdateRoleForm} from "pages/role/UpdateRoleForm"
import {UpdateRoleAttribute} from "pages/role/UpdateRoleAttribute"
import {UpdateRoleUsersInRole} from "pages/role/UpdateRoleUsersInRole"
import {TitleInDetailPage} from "pages/common/TitleInDetailPage"
import {BreadCrumb} from "pages/common/BreadCrumb"
import {PageTabInDetailPage, PageTabItemInDetailPage} from "pages/common/PageTabInDetailPage"

export const UpdateRoleView = () => {
    const {name, view} = useParams<{ name: string, view: "form" | "attribute" | "users-in-role" }>()
    const {data: role} = useFindRoleByName(name)
    const navigate = useNavigate()
    if (!role) {
        return <div>Loading </div>
    }
    return (
        <div className="main-body">
            <BreadCrumb title="Roles" subTitle={`/ ${role?.name}`}/>
            <div className="sub-panel">
                <TitleInDetailPage title={role?.name || ""} iconPath="/img/icon-role.png"/>
                <div className="sub-content-box">
                    <PageTabInDetailPage>
                        <PageTabItemInDetailPage title="Roles 정보" active={view === "form"} iconClass="fa-rectangle-list"
                                                 onClick={() => navigate(`/role/update/${name}/form`)}/>
                        <PageTabItemInDetailPage title="Attributes" active={view === "attribute"} iconClass="fa-list-check"
                                                 onClick={() => navigate(`/role/update/${name}/attribute`)}/>
                        <PageTabItemInDetailPage title="Users in Role" active={view === "users-in-role"} iconClass="fa-user-check"
                                                 onClick={() => navigate(`/role/update/${name}/users-in-role`)}/>
                    </PageTabInDetailPage>
                    {view === "form" && (<UpdateRoleForm/>)}
                    {view === "attribute" && (<UpdateRoleAttribute/>)}
                    {view === "users-in-role" && (<UpdateRoleUsersInRole/>)}
                    <Outlet/>
                </div>
            </div>
        </div>
    )
}